module.exports = require('./lib/axios');


// WEBPACK FOOTER //
// ../node_modules/axios/index.js